// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1QV_d","title":"ClientInsurance_title__2DTIu","itemText":"ClientInsurance_itemText__1T-gm"};